import { render, staticRenderFns } from "./topicTb.vue?vue&type=template&id=1563d2fb&"
import script from "./topicTb.vue?vue&type=script&lang=js&"
export * from "./topicTb.vue?vue&type=script&lang=js&"
import style0 from "./topicTb.vue?vue&type=style&index=0&id=1563d2fb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports